/**
 * French texts of the opening screen that no reason code covers (specs/S2-auth/spec.md §4).
 * Provisional until Q3 (tone): "tu". The failure texts are the C2 reason texts (`reason.<CODE>`),
 * not repeated here.
 *
 * `opening` is the accessible label of the spinner (not shown: the opening state has no visible
 * text); `retry` is the label of the retry button (429, 503, 5xx, network failure).
 */
export const sessionFr = {
  opening: 'Ouverture…',
  retry: 'Réessayer',
};

/**
 * Shape of the opening screen texts. Derived from the French object, like `HomeMessages`: i18next
 * derives the translation keys from it, and an `interface` would not work there (no implicit
 * index signature).
 */
export type SessionMessages = typeof sessionFr;

/** English texts of the opening screen. Provisional until Q3. */
export const sessionEn: SessionMessages = {
  opening: 'Opening…',
  retry: 'Try again',
};
